import { render } from "./AllOnlineAppealCorruption.vue?vue&type=template&id=6d37f44d"
import script from "./AllOnlineAppealCorruption.vue?vue&type=script&lang=js"
export * from "./AllOnlineAppealCorruption.vue?vue&type=script&lang=js"

import "./AllOnlineAppealCorruption.vue?vue&type=style&index=0&id=6d37f44d&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__